export const SCALE_DAY_TIME = 24 * 60 * 60 * 1000;
export const SCALE_HOUR_TIME = 60 * 60 * 1000;
export const SCALE_HALF_HOUR_TIME = 30 * 60 * 1000;
export const CACHE_TIME = 5 * 60 * 1000;
